import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { GraduationCap, Award, FileText } from 'lucide-react';

export const About = () => {
  return (
    <section id="about" className="py-16 sm:py-20 lg:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Section Title */}
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4">
              About <span className="text-gradient-azure">Me</span>
            </h2>
            <div className="w-20 h-1 bg-gradient-azure mx-auto rounded-full"></div>
          </div>

          {/* Professional Summary */}
          <Card className="glass-card mb-8 border-border/50">
            <CardContent className="p-6 sm:p-8">
              <p className="text-base sm:text-lg leading-relaxed text-muted-foreground mb-4">
                Senior Full-Stack Developer with <strong className="text-foreground">10+ years of experience</strong> in software and web application development using Microsoft technologies. Specialized in <strong className="text-foreground">.NET Core, EF Core, Blazor, C#, ASP.NET, Web API, and MVC</strong>.
              </p>
              <p className="text-base sm:text-lg leading-relaxed text-muted-foreground mb-4">
                Expert in <strong className="text-foreground">Azure CI/CD build pipelines, Azure DevOps, Docker, and Kubernetes</strong>. Extensive experience in GUI development using Web Forms and MVC in ASP.NET, with advanced knowledge of <strong className="text-foreground">Angular 18, JavaScript, jQuery, HTML5, and CSS3</strong> in n-tier architecture.
              </p>
              <p className="text-base sm:text-lg leading-relaxed text-muted-foreground">
                Proven capability of translating business requirements to technical specifications, problem-solving, troubleshooting, and debugging complex applications. Skilled in working with <strong className="text-foreground">Azure Functions, Azure Active Directory, Power BI, SSIS, and SSRS</strong>.
              </p>
            </CardContent>
          </Card>

          {/* Education, Certifications & Publications */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Education */}
            <Card className="glass-card border-border/50 hover:shadow-elegant transition-all duration-300">
              <CardContent className="p-6 flex flex-col h-full">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mr-4">
                    <GraduationCap className="w-6 h-6 text-primary" />
                  </div>
                  <h3 className="text-lg font-semibold">Education</h3>
                </div>
                <div className="space-y-3 mt-auto">
                  <div>
                    <p className="font-medium text-foreground">B.Tech in CSE</p>
                    <p className="text-sm text-muted-foreground">KAMALA INSTITUTE OF TECHNOLOGY</p>
                    <p className="text-sm text-muted-foreground">JNTU-H • 2015</p>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Certifications */}
            <Card className="glass-card border-border/50 hover:shadow-elegant transition-all duration-300">
              <CardContent className="p-6 flex flex-col h-full">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 rounded-full bg-accent/10 flex items-center justify-center mr-4">
                    <Award className="w-6 h-6 text-accent" />
                  </div>
                  <h3 className="text-lg font-semibold">Certifications</h3>
                </div>
                <div className="mt-auto">
                  <Badge variant="secondary" className="mb-2">
                    Sitefinity Developer
                  </Badge>
                  <p className="text-sm text-muted-foreground">Certified September 2017</p>
                </div>
              </CardContent>
            </Card>

            {/* Publications */}
            <Card className="glass-card border-border/50 hover:shadow-elegant transition-all duration-300 sm:col-span-2 lg:col-span-1">
              <CardContent className="p-6 flex flex-col h-full">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 rounded-full bg-secondary/10 flex items-center justify-center mr-4">
                    <FileText className="w-6 h-6 text-secondary" />
                  </div>
                  <h3 className="text-lg font-semibold">Publications</h3>
                </div>
                <div className="mt-auto">
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    "Cross-Layer based TCP Protocol for Congestion Control in Multi-hop Mobile Ad hoc Networks"
                  </p>
                  <p className="text-xs text-muted-foreground mt-2">IJCA • 2014</p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};